import React, { createContext, useContext, useState, useCallback } from 'react';
import ConfirmDialog from '../components/common/ConfirmDialog';

const DialogContext = createContext();

export const useDialog = () => {
    const context = useContext(DialogContext);
    if (!context) {
        throw new Error('useDialog must be used within a DialogProvider');
    }
    return context;
};

export const DialogProvider = ({ children }) => {
    const [dialogState, setDialogState] = useState({
        isOpen: false,
        title: '',
        message: '',
        confirmText: 'بەڵێ',
        cancelText: 'نەخێر',
        type: 'danger',
        onConfirm: () => { },
        onCancel: () => { },
    });

    const closeDialog = useCallback(() => {
        setDialogState((prev) => ({ ...prev, isOpen: false }));
    }, []);

    const confirm = useCallback(({
        title,
        message,
        confirmText = 'بەڵێ',
        cancelText = 'نەخێر',
        type = 'danger'
    }) => {
        return new Promise((resolve) => {
            setDialogState({
                isOpen: true,
                title,
                message,
                confirmText,
                cancelText,
                type,
                onConfirm: () => {
                    closeDialog();
                    resolve(true);
                },
                onCancel: () => {
                    closeDialog();
                    resolve(false);
                },
            });
        });
    }, [closeDialog]);

    return (
        <DialogContext.Provider value={{ confirm }}>
            {children}
            <ConfirmDialog
                isOpen={dialogState.isOpen}
                title={dialogState.title}
                message={dialogState.message}
                onConfirm={dialogState.onConfirm}
                onCancel={dialogState.onCancel}
                confirmText={dialogState.confirmText}
                cancelText={dialogState.cancelText}
                type={dialogState.type}
            />
        </DialogContext.Provider>
    );
};
